import React, { useCallback, useMemo } from 'react';

import useMergeProps from '../../../../hooks/useMergeProps';
import useRouter from '../../../../hooks/useRouter';
import { useMissionBannerContext } from '../../contexts/MissionBannerContext';
import { MissionOperationTypes } from '../../types/state/missions';

import MissionExpandButton from './MissionExpandButton';

type PropsType = {
  className?: string;
  missionId: number;
};

const MissionExpandButtonContainer = (ownProps: PropsType) => {
  const { missionId } = ownProps;
  const { history, location } = useRouter();
  const { betRedirectionOnClick, operationType } = useMissionBannerContext();

  const onClick = useCallback(() => {
    if (operationType === MissionOperationTypes.OTHER) {
      betRedirectionOnClick();
    } else {
      const hash = `#mission-details-${missionId}`;

      if (location.hash !== hash) {
        history.push({
          hash,
        });
      }
    }
  }, [betRedirectionOnClick, history, location.hash, missionId, operationType]);

  const actionsProps = useMemo(() => ({ onClick }), [onClick]);

  const enhancedProps = useMergeProps({ ownProps, actionsProps });

  return <MissionExpandButton {...enhancedProps} />;
};

export default MissionExpandButtonContainer;
